exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n.pop-img-scroll img {\n\tmargin-left: -103px;\n  margin-top: -18px;\n  max-width: 80%;\n  max-height: 80%;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.7);\n    -webkit-transition: opacity 50ms;\n    transition: opacity 50ms;\n    visibility: hidden;\n    opacity: 0;\n  }\n  .overlay:target {\n    visibility: visible;\n    opacity: 1;\n  }\n\n  .popup {\n    border-radius: 5px;\n    width: 100%;\n    position: relative;\n    -webkit-transition: all 1s ease-in-out;\n    transition: all 1s ease-in-out;\n    padding:30px;\n  }\n\n  .popup .close {\n    position: absolute;\n    font-size: 30px;\n    font-weight: bold;\n    text-decoration: none;\n    color: #fff;\n    right:30px;\n    top:20px;\n  }\n  .popup .close:hover {\n    color: #06D85F;\n  }\n  .popup .content {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    text-align: center;\n  }\n\n  .popup .content img{\n    zoom: 0.5;\n  }\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/task/taskstructure/task-structure.component.css
// module id = 2037
// module chunks = 0